import { render, staticRenderFns } from "./cadpromocoes.vue?vue&type=template&id=50f8100c&"
import script from "./cadpromocoes.vue?vue&type=script&lang=js&"
export * from "./cadpromocoes.vue?vue&type=script&lang=js&"
import style0 from "./cadpromocoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports